import {PayoutRepository} from "../../domain/types";
import {PayoutRepositoryV2} from "./repository.v2";

export type {PayoutRepository} from "../../domain/types";

/**
 * Creates the PayoutRepository. V1 has been fully retired — this always
 * returns the v2 implementation.
 *
 * @example
 * const repository = createPayoutRepository();
 * const balance = await repository.getWithdrawableBalance();
 */
export const createPayoutRepository = (): PayoutRepository => {
  return new PayoutRepositoryV2();
};
